import axiosInstance from 'src/services/common/axiosInstance'
import { API_ROUTES } from 'src/services/common/routes'

export const postUserLike = async (userId) => {
  try {
    const res = await axiosInstance.post(API_ROUTES.UserLike, {
      current_user_house_id: userId
    })
    return res.data
  } catch (error) {
    console.error('Error posting user like:', error)
    return null
  }
}

export default postUserLike
